// REACT_APP_WS_BASE must be read as a direct process.env property.
// Webpack inlines that expression. A `typeof process` guard stays in the
// browser bundle, process is not defined there, and the base is skipped.
// The dev server proxy does not complete this websocket upgrade, so a
// localhost ws:// URL never reaches the predictions consumer.

export function buildWsUrl(path, locationLike, envBase) {
  const configured = envBase !== undefined ? envBase : process.env.REACT_APP_WS_BASE;
  if (configured) {
    return `${String(configured).replace(/\/$/, "")}${path}`;
  }
  const loc = locationLike || (typeof window !== "undefined" ? window.location : null);
  if (!loc || !loc.host) {
    const secure = !loc || loc.protocol !== "http:";
    const host = (loc && loc.host) || "aviatortrends.com";
    return `${secure ? "wss" : "ws"}://${host}${path}`;
  }
  const hostname = String(loc.hostname || loc.host.split(":")[0]).toLowerCase();
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return `wss://aviatortrends.com${path}`;
  }
  const secure = loc.protocol === "https:";
  return `${secure ? "wss" : "ws"}://${loc.host}${path}`;
}
